import { render, staticRenderFns } from "./HistoryActBeta.vue?vue&type=template&id=6f08e441&"
import script from "./HistoryActBeta.vue?vue&type=script&lang=js&"
export * from "./HistoryActBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports